import { render, staticRenderFns } from "./ForwardBase.vue?vue&type=template&id=1b79bf9a&scoped=true&"
import script from "./ForwardBase.vue?vue&type=script&lang=ts&"
export * from "./ForwardBase.vue?vue&type=script&lang=ts&"
import style0 from "./ForwardBase.vue?vue&type=style&index=0&id=1b79bf9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b79bf9a",
  null
  
)

export default component.exports